import './bootstrap';
import LazyLoad from "vanilla-lazyload";
import {addBackToTop} from "vanilla-back-to-top";

/**
 * Base site class
 */
let Site = function () {

    let lazyLoadInstance;

    /**
     * Init back to top component
     */
    let initBackToTop = function () {
        addBackToTop({
            diameter: 45,
            backgroundColor: 'black',
            textColor: 'white',
        });


        $('#footer-top').click(function () {
            $('#back-to-top').trigger('click')
        });

    };

    /**
     * Init image lazy load component
     */
    let initLazyLoad = function () {

        if (typeof lazyLoadInstance !== 'undefined') {
            return lazyLoadInstance.update();
        }

        lazyLoadInstance = new LazyLoad({
            elements_selector: ".lazy",
            load_delay: 100
        });

        window.lazyLoadInstance = lazyLoadInstance;
    };

    /**
     * Mobile navbar init
     */
    let initNavbar = function () {
        $('.nav-icon').click(function () {
            $(this).toggleClass('open');

            if ($(this).hasClass('open')) {
                $('.main-menu-default').addClass('open');
            } else {
                $('.main-menu-default').removeClass('open');
            }

        });
    };

    let initYearsFilter = function () {
        let filters = $("#years-filter");

        filters.find('a').click(function (e) {

            e.preventDefault();

            if ($(this).hasClass('chrono-month')) {
                filters.find('a.chrono-month').removeClass('active');

                let requestData = {
                    year: $(this).data().year,
                    search: $('input[type="search"]').val(),
                };


                $.get(window.location.href, requestData, function (result) {
                    $('.list-of-articles').empty().append(result.html);
                });

            }

            $(this).toggleClass('active');
            $(this).siblings('ul');
            $(this).siblings('ul').slideToggle('fast');
        });

    };

    let initLetterFilter = function () {
        let filters = $(".letter-filter");

        filters.find('a').click(function (e) {
            e.preventDefault();

            $('input[type="search"]').val("");

            let requestData = {
                letter: $(this).data().letter,
            };


            let filter = $(this);
            $.get(window.location.href, requestData, function (result) {
                $('.list-of-articles').empty().append(result.html);
                filters.find('a.active').removeClass('active');
                filter.toggleClass('active');
                initLazyLoad();
            });

        });

    };


    let initSearch = function () {

        $('input[type="search"]').change(function( event ) {

            $(".letter-filter").find('.active').removeClass('active');

            let query = $(this).val();

            let requestData = {
                search: query,
            };

            if($('.chrono-month.active').length){
                requestData.year = $('a.chrono-month.active').data().year;
            }

            $.get(window.location.href, requestData, function (result) {
                $('.list-of-articles').empty().append(result.html);
                initLazyLoad();
            });

        });
    };


    return {
        /**
         * main function to initiate the module
         */
        init: function () {
            initNavbar();
            initLazyLoad();
            initBackToTop();
            initYearsFilter();
            initLetterFilter();
            initSearch();
        },
    };

}();

/**
 * Init site js
 */
$(document).ready(function () {
    Site.init();
});
